module.exports = __webpack_public_path__ + "static/media/6_CAM.e4507e3a.png";